module.exports = __webpack_public_path__ + "img/favicon_color.ff2d579d.png";